import React from 'react';
import discord from '../../img/discord.png';


const DiscordInviteButton = () => {  
    return (
      <a href="https://discord.aatracker.net" target="_blank" rel="noreferrer">
        <img className="discordButton" src={discord} alt="Button" />
      </a>
    );
  };
  
  export default DiscordInviteButton;